import { useAuthContext } from "../../auth/state/AuthContext";
import { notificationsAtom, userAtom } from "../../shared/atoms";
import { log, logV, logE } from "../../shared/services/debug-logger";
import { getUserNotifications } from "../services/notifications.service";
import NotificationIcon from "./NotificationIcon";
import NotificationList from "./NotificationList";
import { datadogRum } from "@datadog/browser-rum";
import { useAtom, useAtomValue } from "jotai";
import { useEffect, useState } from "react";

const NotificationsDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useAtomValue(userAtom);
  const [_notifications, setNotifications] = useAtom(notificationsAtom);
  const notifications = _notifications ?? [];
  const { sub: email } = useAuthContext().state.user?.accessToken || {};
  logV("NotificationsDrawer - BUILD", { open: isOpen, count: notifications.length, loading: isLoading });

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setIsLoading(true);
        const notifications = await getUserNotifications();
        setNotifications(notifications);
        log("STATE - fetchNotifications - apply", { count: notifications.length });
        setIsLoading(false);
      } catch (error) {
        logE(new Error("NotificationsDrawer - fetchNotifications - failed"));
        setIsLoading(false);
      }
    };

    fetchNotifications();
  }, [user, setNotifications]);

  const toggleDrawerAndMarkAsSeen = async () => {
    log("NotificationsDrawer - toggleDrawerAndMarkAsSeen", { open: !isOpen });
    setIsOpen((prevState) => !prevState);

    if (isOpen) {
      return;
    }
    datadogRum.addAction("openNotificationsList", {
      ext_user_email: email,
    });

    // Mark as seen
    // postAllNotificationsRead(notifications); // This behaviour is unawanted, we want to mark as seen on navigation only
  };

  return (
    <div data-test="notification" className="relative inline-flex">
      <NotificationIcon isOpen={isOpen} onClick={toggleDrawerAndMarkAsSeen} notifications={notifications} />
      {isOpen ? <NotificationList notifications={notifications} isLoading={isLoading} /> : <></>}
    </div>
  );
};

export default NotificationsDrawer;
